/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface Activity
 */
export interface Activity {
    /**
     * 
     * @type {number}
     * @memberof Activity
     */
    id: number;
    /**
     * 
     * @type {User}
     * @memberof Activity
     */
    userId: User;
    /**
     * nom du model
     * @type {string}
     * @memberof Activity
     */
    resModel: string;
    /**
     * nom du res.partner
     * @type {string}
     * @memberof Activity
     */
    resName: string;
    /**
     * id du res.partner
     * @type {number}
     * @memberof Activity
     */
    resId: number;
    /**
     * 
     * @type {Date}
     * @memberof Activity
     */
    dateDeadline: Date;
    /**
     * 
     * @type {string}
     * @memberof Activity
     */
    summary: string;
    /**
     * description en HTML
     * @type {string}
     * @memberof Activity
     */
    note: string;
}

/**
 * Check if a given object implements the Activity interface.
 */
export function instanceOfActivity(value: object): value is Activity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('resModel' in value) || value['resModel'] === undefined) return false;
    if (!('resName' in value) || value['resName'] === undefined) return false;
    if (!('resId' in value) || value['resId'] === undefined) return false;
    if (!('dateDeadline' in value) || value['dateDeadline'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function ActivityFromJSON(json: any): Activity {
    return ActivityFromJSONTyped(json, false);
}

export function ActivityFromJSONTyped(json: any, ignoreDiscriminator: boolean): Activity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': UserFromJSON(json['user_id']),
        'resModel': json['res_model'],
        'resName': json['res_name'],
        'resId': json['res_id'],
        'dateDeadline': (new Date(json['date_deadline'])),
        'summary': json['summary'],
        'note': json['note'],
    };
}

export function ActivityToJSON(json: any): Activity {
    return ActivityToJSONTyped(json, false);
}

export function ActivityToJSONTyped(value?: Activity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user_id': UserToJSON(value['userId']),
        'res_model': value['resModel'],
        'res_name': value['resName'],
        'res_id': value['resId'],
        'date_deadline': value['dateDeadline'].toISOString(),
        'summary': value['summary'],
        'note': value['note'],
    };
}

